<template>
  <div>
    申请有偿转让软件
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>